export default {
    apiKey: 'AIzaSyBXjUq3ySUolmIOydjGeb-nRTttUWzrjS0',
    spreadsheetId: '19H3GLJa8sGfvcfDABwmD3WQPR9hpS_imPFSwjRzykvo'
}
